import { defineMessages } from "react-intl";

export const submitCardMessages = defineMessages({
  cardTitle: {
    defaultMessage: "Return & Replace",
    id: "Z3T6zR",
    description: "card title",
  },
  descrption: {
    defaultMessage:
      "Draft order will be automatically created for replaced products",
    id: "ZTG+Dv",
  },
  submitButton: {
    defaultMessage: "Return and Replace products",
    id: "uN88fb",
    description: "button, submit form",
  },
});
